import { View } from "@-/com.npmjs.react-native";
import Animated, { useAnimatedStyle } from "@-/com.npmjs.react-native-reanimated";
import { slideViewPosition } from "@-/dev.improve.haniverse.routes.nav.app.learn._lib.card-gestures";
import type { LearnCardSlideViews } from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.context";

function SlidePageDot({ index, views }: { index: number; views: LearnCardSlideViews }) {
  const style = useAnimatedStyle(() => {
    // The active dot travels with the view on its way out (or back).
    const position = slideViewPosition(views);
    // 1 on this dot's view, falling to 0 a view away.
    const nearness = Math.max(0, 1 - Math.abs(position - index));
    return { opacity: 0.25 + 0.75 * nearness, width: 6 + 10 * nearness };
  });
  return <Animated.View className="h-1.5 rounded-full bg-foreground" style={style} />;
}

/** One dot per slide above the slideshow; the current slide's dot is long and dark. */
export function SlidePageDots({
  count,
  currentPage,
  views,
}: {
  count: number;
  currentPage: number;
  views: LearnCardSlideViews;
}) {
  return (
    <View
      accessibilityLabel={`Slide ${currentPage + 1} of ${count}`}
      accessibilityRole="progressbar"
      className="absolute inset-x-0 top-4 z-10 flex-row items-center justify-center gap-1.5"
      pointerEvents="none"
      testID="slide-page-dots"
    >
      {Array.from({ length: count }, (_, index) => (
        <SlidePageDot index={index} key={index} views={views} />
      ))}
    </View>
  );
}
